



















































/**
 * @copyright       Palace Resorts
 * @description     Componente IU Card Base
 * @author          CCHAN
 * @creationDate    20/09/2021
 */
import GlobalMixin from "@/mixins/global";
export default GlobalMixin.extend({
  props: {
    color: {
      type: String,
      default: "success",
    },
    icon: {
      type: String,
      default: undefined,
    },
    image: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },

  computed: {
    classes() {
      return {
        "v-card--base--has-heading": Boolean(
          this.$slots.heading || this.title || this.icon
        ),
      };
    },
    hasHeading() {
      return Boolean(this.$slots.heading || this.title || this.icon);
    },
    hasAltHeading() {
      return Boolean(this.$slots.heading || (this.title && this.icon));
    },
  },
});
